import { gql } from "@apollo/client";

export const getAllTaskInLibrary = gql`
query($input: TaskLibraryFilterInput!){
  getAllTaskInLibrary(input: $input) {
    message
    response
  }
}
`;


export const getTaskInLibrary = gql`
query($getTaskInLibraryId: String!){
  getTaskInLibrary(id: $getTaskInLibraryId) {
    message
    response
  }
}
`;